export default {
    more: 'pogledaj više',
    less: 'pogledaj manje',
    likeProduct: 'sviđa mi se proizvod',
    removeButton: 'ukloni',
    removeProduct: 'ukloni proizvod',
    noData: 'nema podataka',
    minimumValueNotReached: 'minimalna cijena narudžbine nije dostignuta',
    shieldIcon: 'ikona štit za sigurno plaćanje',
    searchIcon: 'pretraga',
    noFaqs: 'nema pitanja',
    sliderImage: 'fotografije sa slajdera',
    collapseSubcategories: 'potkategorije',
    notifications: 'notifikacije',
    orders: 'narudžbine',
    wishList: 'omiljeni',
    cart: 'korpa',
    avatar: 'avatar',
    arrowAvatar: 'avatar strelica',
    avatarInactive: 'avatar neaktivan',
    avatarActive: 'avatar aktivan',
    stores: 'prodavnice',
    settings: 'podešavanja',
    help: 'pomoć',
    logout: 'odjava',
    editDeliveryInformation: 'izmijeni informacije o dostavi',
    checkmark: 'štrik',
    orderConfirmed: 'narudžbina potvrđena',
    onDelivery: 'pouzećem',
    addNewAddress: 'dodaj novu adresu',
    chooseNewAddress: 'izaberi novu adresu',
    addToCart: 'dodaj u korpu',
    reviewStar: 'zvijezda',
    resetFilters: 'resetuj filtere',
    noReviews: 'nema recenzija',
    arrowLeft: 'strelica ulijevo',
    arrowRight: 'strelica udesno',
    arrowUp: 'strelica gore',
    arrowDown: 'strelica dolje',
    cancel: 'otkaži',
    cardView: 'pregled kartice',
    delete: 'izbriši',
    noFavourites: 'nema omiljenih',
    edit: 'izmijeni',
    show: 'pokaži',
    hide: 'sakrij',
    selectPhoneNumber: 'Izaberi broj telefona',
    resendCode: 'ponovo pošalji kod',
    recoveryCodes: 'kodovi za oporavak',
    verified: 'verifikovano',
    authentificationAppIcon: 'Ikonica za autentifikaciju',
    qrCode: 'Qr kod',
    protectAccountIcon: 'zaštiti profil',
    desktop: 'desktop',
    mobile: 'mobilni',
    tablet: 'tablet',
    dots: 'tačke',
    previousProduct: 'prethodni proizvod',
    nextProduct: 'sljedeći proizvod',
    comment: 'komentar',
    user: 'korisnik',
    product: 'proizvod',
    noNotifications: 'nema obavještenja',
    close: 'zatvori',
    message: 'poruka',
    categories: 'kategorije',
    bill: 'račun'
}
